import { PaymentMethodType } from '@/modules/user/user.types';

export enum PaymentMethodLayout {
  Boxed = 'boxed',
  Divider = 'divider',
}

export const PaymentMethodTiming = {
  [PaymentMethodType.DIRECT_DEPOSIT]: '1-3 days once approved',
  [PaymentMethodType.CHECK]: '5-7 days once approved',
  [PaymentMethodType.PAYPAL]: 'Under 10 minutes once approved',
  [PaymentMethodType.DEBIT]: 'Under 10 minutes once approved',
  [PaymentMethodType.VENMO]: 'Under 10 minutes once approved',
};
